import { LayoutServicePageState, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState, JSX } from 'react';
import { GoogleTagManager } from '@next/third-parties/google';

const TagManager = (): JSX.Element => {
  const {
    sitecoreContext: { pageState, route, variantId, site },
  } = useSitecoreContext();

  const [shouldLoadTagManager, setShouldLoadTagManager] = useState(false);

  /**
   * Determines if data dog monitoring should be turned off.
   * By default it is disabled in development mode
   */
  const disabled = () => {
    return process.env.NODE_ENV === 'development';
  };

  useEffect(() => {
    // Do not load in editing or preview mode or if missing route data
    if (pageState !== LayoutServicePageState.Normal || !route?.itemId) {
      return;
    }
    // Do not load if disabled
    if (disabled()) {
      return;
    }

    setShouldLoadTagManager(true);
  }, [pageState, route, variantId, site]);

  return shouldLoadTagManager ? (
    <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GtmId ?? ''} />
  ) : (
    <></>
  );
};

export default TagManager;
